module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_vestland_pos.cb377fa6.png";